// extracted by mini-css-extract-plugin
module.exports = {"base":"Item_base__1f1Ne","active":"Item_active__2B88B"};